<template lang="html">
    <section class="app-content">
        <router-view name="app_content"></router-view>
    </section>
</template>

<script>
    export default {
    }
</script>

<style lang="stylus" scoped>
    @require '../../assets/css/variables'

    section.app-content {
        height: 100%
        width: $app-content-width
        padding: $app-content-padding
        background: $app-content-background
        z-index: initial
    }
</style>



// WEBPACK FOOTER //
// src/layouts/app/Content.vue